import { useState, useMemo } from 'react'
import { DataTable } from '../../components/DataTable.jsx'
import { MetricFunnel } from '../../components/Metrics.jsx'

function enrichWithCAC(data) {
  return data.map(item => ({
    ...item,
    cac: item.sales > 0 ? (item.cost || 0) / item.sales : 0
  }))
}

// Colunas para cada nível
const ACCOUNT_COLUMNS = [
  { key: 'name', label: 'Conta', sortable: true },
  { key: 'cost', label: 'Investimento', format: 'currency', sortable: true, align: 'right' },
  { key: 'impressions', label: 'Impressões', format: 'number', sortable: true, align: 'right' },
  { key: 'clicks', label: 'Cliques', format: 'number', sortable: true, align: 'right' },
  { key: 'visits', label: 'Visitas', format: 'number', sortable: true, align: 'right' },
  { key: 'whatsappClicks', label: 'Cliques WhatsApp', format: 'number', sortable: true, align: 'right' },
  { key: 'forms', label: 'Formulários', format: 'number', sortable: true, align: 'right' },
  { key: 'contacts', label: 'Contatos', format: 'number', sortable: true, align: 'right' },
  { key: 'leads', label: 'Leads', format: 'number', sortable: true, align: 'right' },
  { key: 'qualifiedLeads', label: 'Lead qualificado', format: 'number', sortable: true, align: 'right' },
  { key: 'sales', label: 'Vendas', format: 'number', sortable: true, align: 'right' },
  { key: 'revenue', label: 'Valor Total de Vendas', format: 'currency', sortable: true, align: 'right' },
  { key: 'ticketMedio', label: 'Ticket Médio', format: 'currency', sortable: true, align: 'right' },
  { key: 'cac', label: 'CAC', format: 'currency', sortable: true, align: 'right' },
]

const CAMPAIGN_COLUMNS = [
  { key: 'name', label: 'Campanha', sortable: true },
  { key: 'accountName', label: 'Conta', sortable: true },
  { key: 'status', label: 'Status', type: 'badge', sortable: true },
  { key: 'cost', label: 'Investimento', format: 'currency', sortable: true, align: 'right' },
  { key: 'impressions', label: 'Impressões', format: 'number', sortable: true, align: 'right' },
  { key: 'clicks', label: 'Cliques', format: 'number', sortable: true, align: 'right' },
  { key: 'visits', label: 'Visitas', format: 'number', sortable: true, align: 'right' },
  { key: 'whatsappClicks', label: 'Cliques WhatsApp', format: 'number', sortable: true, align: 'right' },
  { key: 'forms', label: 'Formulários', format: 'number', sortable: true, align: 'right' },
  { key: 'contacts', label: 'Contatos', format: 'number', sortable: true, align: 'right' },
  { key: 'leads', label: 'Leads', format: 'number', sortable: true, align: 'right' },
  { key: 'qualifiedLeads', label: 'Lead qualificado', format: 'number', sortable: true, align: 'right' },
  { key: 'sales', label: 'Vendas', format: 'number', sortable: true, align: 'right' },
  { key: 'revenue', label: 'Valor Total de Vendas', format: 'currency', sortable: true, align: 'right' },
  { key: 'ticketMedio', label: 'Ticket Médio', format: 'currency', sortable: true, align: 'right' },
  { key: 'cac', label: 'CAC', format: 'currency', sortable: true, align: 'right' },
]

const AD_GROUP_COLUMNS = [
  { key: 'name', label: 'Grupo de Anúncios', sortable: true },
  { key: 'campaignName', label: 'Campanha', sortable: true },
  { key: 'accountName', label: 'Conta', sortable: true },
  { key: 'status', label: 'Status', type: 'badge', sortable: true },
  { key: 'cost', label: 'Investimento', format: 'currency', sortable: true, align: 'right' },
  { key: 'impressions', label: 'Impressões', format: 'number', sortable: true, align: 'right' },
  { key: 'clicks', label: 'Cliques', format: 'number', sortable: true, align: 'right' },
  { key: 'visits', label: 'Visitas', format: 'number', sortable: true, align: 'right' },
  { key: 'whatsappClicks', label: 'Cliques WhatsApp', format: 'number', sortable: true, align: 'right' },
  { key: 'forms', label: 'Formulários', format: 'number', sortable: true, align: 'right' },
  { key: 'contacts', label: 'Contatos', format: 'number', sortable: true, align: 'right' },
  { key: 'leads', label: 'Leads', format: 'number', sortable: true, align: 'right' },
  { key: 'qualifiedLeads', label: 'Lead qualificado', format: 'number', sortable: true, align: 'right' },
  { key: 'sales', label: 'Vendas', format: 'number', sortable: true, align: 'right' },
  { key: 'revenue', label: 'Valor Total de Vendas', format: 'currency', sortable: true, align: 'right' },
  { key: 'ticketMedio', label: 'Ticket Médio', format: 'currency', sortable: true, align: 'right' },
  { key: 'cac', label: 'CAC', format: 'currency', sortable: true, align: 'right' },
]

const AD_COLUMNS = [
  { key: 'name', label: 'Anúncio', sortable: true },
  { key: 'groupName', label: 'Grupo', sortable: true },
  { key: 'campaignName', label: 'Campanha', sortable: true },
  { key: 'status', label: 'Status', type: 'badge', sortable: true },
  { key: 'cost', label: 'Investimento', format: 'currency', sortable: true, align: 'right' },
  { key: 'impressions', label: 'Impressões', format: 'number', sortable: true, align: 'right' },
  { key: 'clicks', label: 'Cliques', format: 'number', sortable: true, align: 'right' },
  { key: 'visits', label: 'Visitas', format: 'number', sortable: true, align: 'right' },
  { key: 'whatsappClicks', label: 'Cliques WhatsApp', format: 'number', sortable: true, align: 'right' },
  { key: 'forms', label: 'Formulários', format: 'number', sortable: true, align: 'right' },
  { key: 'contacts', label: 'Contatos', format: 'number', sortable: true, align: 'right' },
  { key: 'leads', label: 'Leads', format: 'number', sortable: true, align: 'right' },
  { key: 'qualifiedLeads', label: 'Lead qualificado', format: 'number', sortable: true, align: 'right' },
  { key: 'sales', label: 'Vendas', format: 'number', sortable: true, align: 'right' },
  { key: 'revenue', label: 'Valor Total de Vendas', format: 'currency', sortable: true, align: 'right' },
  { key: 'ticketMedio', label: 'Ticket Médio', format: 'currency', sortable: true, align: 'right' },
  { key: 'cac', label: 'CAC', format: 'currency', sortable: true, align: 'right' },
]

export default function QuantitativePage({ data, level, onDrillDown, whatsappTotalOverride = null }) {

  const dataWithCAC = useMemo(() => enrichWithCAC(data), [data])

  const totals = useMemo(() => {
    const sums = data.reduce((acc, item) => ({
      cost: acc.cost + (item.cost || 0),
      impressions: acc.impressions + (item.impressions || 0),
      clicks: acc.clicks + (item.clicks || 0),
      visits: acc.visits + (item.visits || 0),
      whatsappClicks: acc.whatsappClicks + (item.whatsappClicks || 0),
      forms: acc.forms + (item.forms || 0),
      contacts: acc.contacts + (item.contacts || 0),
      leads: acc.leads + (item.leads || 0),
      qualifiedLeads: acc.qualifiedLeads + (item.qualifiedLeads || 0),
      sales: acc.sales + (item.sales || 0),
      revenue: acc.revenue + (item.revenue || 0),
    }), {
      cost: 0, impressions: 0, clicks: 0, visits: 0, whatsappClicks: 0,
      forms: 0, contacts: 0, leads: 0, qualifiedLeads: 0, sales: 0, revenue: 0
    })

    return {
      ...sums,
      ticketMedio: sums.sales > 0 ? sums.revenue / sums.sales : 0,
      cac: sums.sales > 0 ? sums.cost / sums.sales : 0
    }
  }, [data])

  const columns = useMemo(() => {
    switch (level) {
      case 'account': return ACCOUNT_COLUMNS
      case 'campaign': return CAMPAIGN_COLUMNS
      case 'adgroup': return AD_GROUP_COLUMNS
      case 'ad': return AD_COLUMNS
      default: return ACCOUNT_COLUMNS
    }
  }, [level])

  return (
    <div className="ga-page">
      <MetricFunnel
        rows={[
          [
            { label: 'Impressões', value: totals.impressions, format: 'number' },
            { label: 'Cliques', value: totals.clicks, format: 'number' },
            { label: 'Visitas', value: totals.visits, format: 'number' },
            { label: 'Cliques WhatsApp', value: whatsappTotalOverride != null ? whatsappTotalOverride : totals.whatsappClicks, format: 'number' },
            { label: 'Formulários', value: totals.forms, format: 'number' },
            { label: 'Contatos', value: totals.contacts, format: 'number' },
            { label: 'Leads', value: totals.leads, format: 'number' },
            { label: 'Leads Qualificados', value: totals.qualifiedLeads, format: 'number' },
            { label: 'Vendas', value: totals.sales, format: 'number' },
          ],
          [
            { label: 'Investimento', value: totals.cost, format: 'currency' },
            { label: 'Valor Total de Vendas', value: totals.revenue, format: 'currency' },
            { label: 'Ticket Médio', value: totals.ticketMedio, format: 'currency' },
            { label: 'CAC', value: totals.cac, format: 'currency' },
          ],
        ]}
      />

      <div className="table-section">
        <div className="table-section-header">
          <div>
            <div className="table-section-title">
              Dados {level === 'account' ? 'por Conta' : level === 'campaign' ? 'por Campanha' : level === 'adgroup' ? 'por Grupo' : 'por Anúncio'}
            </div>
            <div className="table-section-subtitle">
              Clique no cabeçalho da coluna para ordenar • Clique na linha para detalhar
            </div>
          </div>
        </div>
        <DataTable
          key={level}
          columns={columns}
          data={dataWithCAC}
          hoverable
          striped
          scrollable
          onRowClick={onDrillDown}
          emptyText="Nenhum dado encontrado para os filtros selecionados"
        />
      </div>
    </div>
  )
}